export default {
  init (e) {
      var elementTop = $(e).offset().top;
      var elementBottom = elementTop + $(e).outerHeight();
    
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
    
      return elementTop >= viewportTop && elementBottom <= viewportBottom;
    
  }
}
